/**
 * Availability flag for the v2 visual workflow builder.
 *
 * The workflow step defaults to V2 while retaining the Classic editor as a
 * user-selectable fallback.
 */
export const WORKFLOW_BUILDER_V2_ENABLED = true;

export function isWorkflowBuilderV2Enabled(): boolean {
  return WORKFLOW_BUILDER_V2_ENABLED;
}
